import React from "react";
import { useActiveQueue, ActiveQueueTableRow } from "pages/dashboard/queue/tabs/active";
import { Table } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

export const ActiveQueueTable = props => {

    const { entries } = useActiveQueue();

    return (
        <Table className="m-0" borderless striped>
            <thead>
                <tr>
                    <th>
                        <FormattedMessage
                            defaultMessage="Position"
                            id="label.position"
                        />
                    </th>
                    <th>
                        <FormattedMessage
                            defaultMessage="Application User"
                            id="label.application_user"
                        />
                    </th>
                    <th>
                        <FormattedMessage
                            defaultMessage="Start Time"
                            id="label.start_time"
                        />
                    </th>
                </tr>
            </thead>
            <tbody>
                {entries?.length ?
                (
                    <>
                        {entries.map((entry, key) => (
                            <ActiveQueueTableRow entry={entry} idx={key} key={key} />
                        ))}
                    </>
                )
                :
                (
                    <tr>
                        <td colSpan={3} className="text-center">
                            <span>
                                <FormattedMessage
                                    defaultMessage="No users in queue"
                                    id="label.no_users_in_queue"
                                        />
                            </span>
                        </td>
                    </tr>
                )
            }
            </tbody>
        </Table>
    );

};